import dayjs, { type Dayjs } from 'dayjs';

/**
 * Ritorna `true` se il tipo domanda è avviabile in base alle date indicate.
 */
export function isInquiryTypeStartable(
  startDate: Dayjs | null | undefined,
  endDate: Dayjs | null | undefined,
) {
  const now = dayjs().startOf('day');

  return (
    (!startDate || startDate.isSame(now) || startDate.isBefore(now)) &&
    (!endDate || endDate.isAfter(now) || endDate.isSame(now))
  );
}
